var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resource',{attrs:{"resource":"moderator","resourceName":"Moderator","attributes":_vm.attributes}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Moderator erstellen")])])])}
var staticRenderFns = []

export { render, staticRenderFns }